/**
 * Access profile helpers — JM Operator and future named profiles.
 */

const JM_OPERATOR_PROFILE = 'jm_operator';

/**
 * True when the user has the JM Operator access profile (or equivalent menu grants).
 * @param {{ accessProfile?: string, allowedRoutes?: string[] }} manifest
 */
export function isJmOperatorProfile(manifest) {
  if (!manifest) return false;
  if (manifest.accessProfile === JM_OPERATOR_PROFILE) return true;

  const routes = manifest.allowedRoutes || [];
  const hasJm = routes.some((r) => r.startsWith('/operations/jm'));
  const hasOtherOps = routes.some(
    (r) => r.startsWith('/operations/') && !r.startsWith('/operations/jm'),
  );
  const hasProjectChildren = routes.some(
    (r) => r.startsWith('/projects/') && r !== '/projects',
  );
  const hasProjectsParent = routes.includes('/projects');

  return hasJm && hasProjectsParent && !hasOtherOps && !hasProjectChildren;
}

/**
 * Default landing path for profile-focused users (e.g. JM dashboard).
 * @param {{ defaultLanding?: string, accessProfile?: string }} manifest
 */
export function getProfileDefaultLanding(manifest) {
  if (!manifest) return null;
  if (manifest.defaultLanding) return manifest.defaultLanding;
  if (manifest.accessProfile === JM_OPERATOR_PROFILE) return '/operations/jm';
  return null;
}

export { JM_OPERATOR_PROFILE };
